<div class="labelInputs">
    <label>{{placeholder}}</label>
</div>